import PptxGenJS from 'pptxgenjs';
import PowerPointSlideProcessor from '@app/services/export/ppt/slides/PowerPointSlideProcessor';
import {
	createBadgeForSlide,
	createImageForSlide,
	createLogoForSlide
} from '@app/services/export/ppt/utils/layoutUtils';
import ICustomSlideData from '@app/types/data/slides/ICustomSlideData';
import {
	colors,
	defaultViewPortPadding,
	presentationDimensions,
	spacing
} from '@app/services/export/ppt/variables/constants';
import { gridCol } from '@app/services/export/ppt/utils/gridUtils';
import { copy, h2 } from '@app/services/export/ppt/variables/typography';
import { richTextToPptxText } from '@app/services/export/ppt/utils/formattingUtils';
import TextProps = PptxGenJS.TextProps;

export default class PowerPointCustomSlideProcessor extends PowerPointSlideProcessor<ICustomSlideData> {
	public async processSlideData(): Promise<void> {
		const slide: PptxGenJS.Slide = this.presentation.addSlide();
		const textArray: TextProps[] = [];

		// image
		if (this.slideData.image) {
			createImageForSlide(slide, this.slideData.image, {
				destinationWidth: presentationDimensions.w / 2,
				destinationHeight: presentationDimensions.h,
				type: 'cover',
				x: 0,
				y: 0
			});
		}

		// text
		if (this.slideData.headline) {
			textArray.push({
				text: this.slideData.headline,
				options: { breakLine: true, ...h2, paraSpaceAfter: spacing.default }
			});
		}

		if (this.slideData.copy) {
			textArray.push(...richTextToPptxText(this.slideData.copy));
		}

		slide.addText(textArray, {
			...gridCol(7, 5),
			...copy,
			color: colors.blue,
			y: defaultViewPortPadding.vertical,
			h: presentationDimensions.h - defaultViewPortPadding.vertical * 2,
			margin: [0, 0, 0, 0]
		});

		// badge
		if (this.slideData.badgeText) {
			createBadgeForSlide(slide, this.slideData.badgeText, {
				x: presentationDimensions.w / 2 - 0.3,
				y: 0.8
			});
		}

		createLogoForSlide(slide);
	}
}
